import {
    Typography,
    Box,
    Link
} from '@mui/material'
import colors from '../../constants/colors'

export default function ItemApproved(props) {
    const {
        isMobile
    } = props;

    const textStyle = {
        fontFamily: 'Open Sans'
    }

    return (
        <Box
            sx={{
                p: 4
            }}
        >
            <Typography
                variant='h4'
                sx={{
                    ...textStyle,
                    textAlign: 'center',
                    mb: 2
                }}
            >
                Item added to the collection!
            </Typography>
            <Box
                sx={{
                    textAlign: 'center'
                }}
            >
                <Box
                    sx={{
                        m: 'auto',
                        width: !isMobile ? 450 : "100%"
                    }}
                >
                    <Typography
                        variant='body1'
                        sx={{
                            ...textStyle,
                            textAlign: 'center',
                            color: colors.gray
                        }}
                    >
                        The item was automatically approved since you are a curator!
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}


